/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireResultResidualRisk } from './CustomQuestionnaireResultResidualRisk';
import {
  CustomQuestionnaireResultResidualRiskFromJSON,
  CustomQuestionnaireResultResidualRiskFromJSONTyped,
  CustomQuestionnaireResultResidualRiskToJSON,
} from './CustomQuestionnaireResultResidualRisk';
import type { CustomQuestionnaireSummary } from './CustomQuestionnaireSummary';
import {
  CustomQuestionnaireSummaryFromJSON,
  CustomQuestionnaireSummaryFromJSONTyped,
  CustomQuestionnaireSummaryToJSON,
} from './CustomQuestionnaireSummary';
import type { CustomQuestionnaireAnswerRead } from './CustomQuestionnaireAnswerRead';
import {
  CustomQuestionnaireAnswerReadFromJSON,
  CustomQuestionnaireAnswerReadFromJSONTyped,
  CustomQuestionnaireAnswerReadToJSON,
} from './CustomQuestionnaireAnswerRead';
import type { UseCaseName } from './UseCaseName';
import { UseCaseNameFromJSON, UseCaseNameFromJSONTyped, UseCaseNameToJSON } from './UseCaseName';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswerSetRead
 */
export interface CustomQuestionnaireAnswerSetRead {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly id: number;
  /**
   *
   * @type {UseCaseName}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly useCase: UseCaseName;
  /**
   *
   * @type {CustomQuestionnaireSummary}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly questionnaire: CustomQuestionnaireSummary;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly createdBy: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly updatedBy: string;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly updatedAt: Date;
  /**
   *
   * @type {boolean}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  isDraft?: boolean;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  lastConfirmedStep?: number | null;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswerRead>}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  answers: Array<CustomQuestionnaireAnswerRead>;
  /**
   *
   * @type {Array<CustomQuestionnaireResultResidualRisk>}
   * @memberof CustomQuestionnaireAnswerSetRead
   */
  readonly residualRisks: Array<CustomQuestionnaireResultResidualRisk>;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerSetRead interface.
 */
export function instanceOfCustomQuestionnaireAnswerSetRead(value: object): value is CustomQuestionnaireAnswerSetRead {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  if (!('questionnaire' in value) || value['questionnaire'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
  if (!('answers' in value) || value['answers'] === undefined) return false;
  if (!('residualRisks' in value) || value['residualRisks'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerSetReadFromJSON(json: any): CustomQuestionnaireAnswerSetRead {
  return CustomQuestionnaireAnswerSetReadFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerSetReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerSetRead {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    useCase: UseCaseNameFromJSON(json['use_case']),
    questionnaire: CustomQuestionnaireSummaryFromJSON(json['questionnaire']),
    createdBy: json['created_by'],
    updatedBy: json['updated_by'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
    isDraft: json['is_draft'] == null ? undefined : json['is_draft'],
    lastConfirmedStep: json['last_confirmed_step'] == null ? undefined : json['last_confirmed_step'],
    answers: (json['answers'] as Array<any>).map(CustomQuestionnaireAnswerReadFromJSON),
    residualRisks: (json['residual_risks'] as Array<any>).map(CustomQuestionnaireResultResidualRiskFromJSON),
  };
}

export function CustomQuestionnaireAnswerSetReadToJSON(
  value?: Omit<
    CustomQuestionnaireAnswerSetRead,
    'id' | 'useCase' | 'questionnaire' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt' | 'residualRisks'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    is_draft: value['isDraft'],
    last_confirmed_step: value['lastConfirmedStep'],
    answers: (value['answers'] as Array<any>).map(CustomQuestionnaireAnswerReadToJSON),
  };
}
